import React from "react";
import { Dropdown, Badge } from "react-bootstrap";
import dayjs from "dayjs";
import {
  useNotifications,
  useMarkNotificationRead,
  useMarkAllNotificationsRead,
} from "./useNotifications";

/**
 * Bell in the navbar with an unread count and a dropdown inbox.
 * Clicking a notification marks it read.
 */
function NotificationBell() {
  const { data } = useNotifications();
  const markRead = useMarkNotificationRead();
  const markAll = useMarkAllNotificationsRead();

  const unread = data?.unread ?? 0;
  const items = data?.results ?? [];

  return (
    <Dropdown align="end">
      <Dropdown.Toggle
        as="button"
        className="btn btn-link position-relative p-2 border-0 text-reset"
        id="notification-bell"
        aria-label={`Notificaciones${unread ? `, ${unread} sin leer` : ""}`}
        style={{ minHeight: 40, minWidth: 40 }}
      >
        <i className="mdi mdi-bell-outline" style={{ fontSize: 22 }} />
        {unread > 0 && (
          <Badge
            bg="danger"
            pill
            className="position-absolute top-0 start-100 translate-middle"
            style={{ fontSize: ".65rem" }}
          >
            {unread > 9 ? "9+" : unread}
          </Badge>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu
        style={{ width: 340, maxHeight: 420, overflowY: "auto" }}
        className="shadow"
      >
        <div className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
          <strong className="small">Notificaciones</strong>
          {unread > 0 && (
            <button
              className="btn btn-link btn-sm p-0 text-decoration-none"
              onClick={() => markAll.mutate()}
            >
              Marcar todas leídas
            </button>
          )}
        </div>

        {items.length === 0 && (
          <div className="text-muted small text-center py-4 px-3">
            No tienes notificaciones.
          </div>
        )}

        {items.map((n) => (
          <button
            key={n.id}
            className={`dropdown-item text-wrap py-2 ${
              n.is_read ? "" : "bg-light"
            }`}
            onClick={() => !n.is_read && markRead.mutate(n.id)}
            style={{ whiteSpace: "normal" }}
          >
            <div className="d-flex justify-content-between align-items-start gap-2">
              <span className="fw-medium small">{n.title}</span>
              {!n.is_read && (
                <span
                  className="rounded-circle bg-primary flex-shrink-0 mt-1"
                  style={{ width: 8, height: 8 }}
                  aria-hidden="true"
                />
              )}
            </div>
            {n.body && (
              <div className="text-muted small mt-1">{n.body}</div>
            )}
            <div className="text-muted" style={{ fontSize: ".7rem" }}>
              {dayjs(n.created_at).format("D MMM · HH:mm")}
            </div>
          </button>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export { NotificationBell };
